import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap } from 'rxjs/operators'
import { SnackbarService } from '../../components/snackbar/service/snackbar.service'
import { SNACKBAR_CLASS } from '../../components/snackbar/model/snackbar.model'
import { LoadingService } from '../../service/loading/loading.service'
import { I18nService } from '../../i18n/service/i18n.service'
import { ProfileManagementService } from '../../service/store-management/profile-management/profile-management.service'
import { InterceptorSkip } from '../error-interceptor/error.interceptor'

@Injectable()
export class HttpALDInterceptor implements HttpInterceptor {
	constructor(private snack: SnackbarService, private loading: LoadingService, private i18n: I18nService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (!req?.url.includes('notifications') || !req?.url.includes('notification')) {
			this.loading.setLoading(true, req.url)
		}
		return next.handle(req).pipe(
			tap(
				(event) => {
					if (event instanceof HttpResponse) {
						this.manageSuccessStatus(event.status)
						this.loading.setLoading(false, req.url)
						// TODO will be manage api
					}
				},
				(err) => {
					this.loading.setLoading(false, req.url);
					if (req.headers && req.headers.has(InterceptorSkip)) {
						return next.handle(req);
					} else {
						this.openSnack(err.statusText, SNACKBAR_CLASS.ERROR_CLASS)
						return next.handle(req);
					}
				}
			)
		)
	}

	manageSuccessStatus(status): void {
		let message = ''
		switch (status) {
			case 204:
				message = this.i18n.getTranslation('no_content')
				this.snack.openSnackReferClassWithTranslationEmbedded(message, SNACKBAR_CLASS.WARNING_CLASS)
				break
		}
	}

	openSnack(message: string, type: string) {
		const snackData: any = {}
		snackData.message = message
		snackData.type = type
		this.snack.openSnackBar(snackData)
	}
}
